import { useCurrentShopQuery } from '@modules/Dashboard/hooks/useCurrentShopQuery';
import { useHMACQuery } from '../queries/useHMACQuery';
import { useUpdateHMACMutation } from '../queries/useUpdateHMACMutation';
export const useHMAC = () => {
    const { currentShopQuery } = useCurrentShopQuery();
    const { hmacQuery } = useHMACQuery([currentShopQuery.data?.id], {
        enabled: !!currentShopQuery.data?.id,
    });
    const { updateHMACMutation } = useUpdateHMACMutation({
        onSuccess: () => {
            hmacQuery.refetch();
        },
    });
    return {
        hmac: hmacQuery.data,
        loading: hmacQuery.isLoading,
        updateHMAC: updateHMACMutation.mutate,
        updateLoading: updateHMACMutation.isLoading,
    };
};
